import React from 'react';
import { Alert, Button, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';

/**
 * Control Bridge: inform snapshot-only users and link back to intake (ISSUE-245).
 */
export const OnboardingSnapshotBanner: React.FC = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const o = user?.onboarding;

  if (!o?.snapshotOnly || o.coreActive) {
    return null;
  }

  return (
    <Alert
      type="info"
      showIcon
      style={{ margin: '0 24px 16px' }}
      message="Snapshot mode"
      description={
        <Space direction="vertical" size="small" style={{ width: '100%' }}>
          <span>
            Your account is in snapshot-only mode until your foundation model is complete. Explore the
            Control Bridge; deep improvements and some agent actions stay gated until subscription is
            active.
          </span>
          <Button size="small" type="primary" onClick={() => navigate('/onboarding/prospector')}>
            Continue discovery chat
          </Button>
        </Space>
      }
    />
  );
};
